class a {
  constructor(t, e) {
    (this.host = t).addController(this), this.events = e.reduce((n, r) => (n[r] = (s) => {
      var o;
      const h = new CustomEvent("p" + r.substring(2), {
        cancelable: !0,
        bubbles: !0,
        detail: { originalEvent: s }
      });
      ((o = s.target) == null ? void 0 : o.dispatchEvent(h)) || s.preventDefault();
    }, n), {});
  }
  hostConnected() {
    Object.entries(this.events).forEach(([t, e]) => {
      this.host.addEventListener(t, e);
    });
  }
  hostDisconnected() {
    Object.entries(this.events).forEach(([t, e]) => {
      this.host.removeEventListener(t, e);
    });
  }
}
export {
  a as S
};
